module.exports = __webpack_public_path__ + "img/8bfd62b0c842ff7ad2df196ac92e862a.fbf458d6.jpg";